import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getBackendDataCollectionsExtensionsDir } from '@wix/cli-astro-definitions';
import { isStandaloneExtensionsProject } from '@wix/cli-custom-extensions';
import { pathExists } from '@wix/cli-fs';
import { getExtensionRelativePaths } from '../utils/extension-relative-paths.js';
import { modifyDataCollectionsExtension } from './modify-data-collections-extension.js';

const EXTENSION_NAME = 'data-collections';
const COLLECTION_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/data-collections'
);

export async function generateDataCollection(
  projectFolder: string,
  collectionName: string
) {
  const cwd = getBackendDataCollectionsExtensionsDir(projectFolder);
  const { relativePathToConfigFile } = getExtensionRelativePaths({
    cwd,
    projectFolder,
    extensionFileName: EXTENSION_NAME,
    codeFileType: 'ts',
  });
  const extensionFilePath = path.join(cwd, `${EXTENSION_NAME}.extension.ts`);

  const extensionExists = await pathExists(extensionFilePath);
  const isCustomExtensionsProject =
    await isStandaloneExtensionsProject(projectFolder);

  const results = await componentGenerator({
    template: COLLECTION_TEMPLATE,
    cwd,
    projectFolder,
    data: {
      builderPackage: isCustomExtensionsProject
        ? '@wix/custom-extensions'
        : '@wix/astro/builders',
      extensionFileExists: extensionExists,
      collectionName,
      config: {
        id: randomUUID(),
      },
    },
  });

  await modifyExtensionsEntry({
    projectFolder,
    extensionName: camelCase(EXTENSION_NAME),
    relativePath: relativePathToConfigFile,
    isCustomExtensionsProject,
  });

  await modifyDataCollectionsExtension(extensionFilePath, collectionName);

  return results;
}
